export const ICON_TYPES = {
  Verified: 'verified',
  PendingActions: 'pending_actions',
  Warning: 'warning',
  OtherAdmission: 'other_admission',
  Chronic: 'chronic', //Pending Approval
  DomainAdd: 'domain_add', //Org Unit Timeline
  DomainDisabled: 'domain_disabled', //Org Unit Timeline
  PersonAlert: 'person_alert', //need observer
  KeyboardArrowUp: 'keyboard_arrow_up',
  KeyboardArrowDown: 'keyboard_arrow_down',
  Outbound: 'outbound' //DC Event
};
